import React from 'react';
import PropTypes from 'prop-types';
import Close from '@material-ui/icons/Close';
import { FormattedMessage } from 'react-intl';
import { IconButton, Popover, Typography, Box, Button, withStyles } from '@material-ui/core';
import LogoSimple from 'assets/img/logo-simple.png';

const styles = (theme) => ({
  popover: {
    margin: theme.spacing(2),
    zIndex: '1305 !important',
  },
  paper: {
    maxWidth: 360,
    padding: theme.spacing(2),
  },
  email: {
    backgroundColor: theme.palette.primary[100],
    padding: theme.spacing(0.25),
  },
  titleGroup: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  img: {
    width: '35px',
  },
  smallBtn: {
    padding: '0px 4px',
    fontSize: '0.7rem',
  },
});

class ContactsWarning extends React.Component {
  state = {
    anchorEl: null,
  };

  handlePopoverOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, placeholder, terminationWarning, onCancel, isHost } = this.props;

    const { anchorEl } = this.state;

    return (
      <>
        {placeholder && (
          <span
            role="button"
            tabIndex={-1}
            aria-owns={anchorEl ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            className={classes.email}
            onClick={this.handlePopoverOpen}
            onMouseEnter={this.handlePopoverOpen}
          >
            {placeholder}
          </span>
        )}
        <Popover
          disableRestoreFocus
          marginThreshold={32}
          id="mouse-over-popover"
          open={!!anchorEl}
          anchorEl={anchorEl}
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          onCancel={this.handlePopoverClose}
        >
          <div className={classes.titleGroup}>
            <Box flex={1}>
              <img src={LogoSimple} alt="logo" className={classes.img} />
            </Box>
            <Box flex={1} textAlign="right">
              <IconButton color="inherit" aria-label="Close" onClick={this.handlePopoverClose}>
                <Close fontSize="small" />
              </IconButton>
            </Box>
          </div>
          {!isHost && (
            <Typography>
              <FormattedMessage
                id="conversations.warningPopoverText"
                defaultMessage="This accommodation is S-certified.
                    For your security, we recommend that all communication
                    should take place via stugknuten.com.
                    Managing your payment via Stugknuten provides you with increased security
                    and does not involve any extra costs for you as guest."
              />
              <br />
              <br />
              <FormattedMessage
                id="conversations.warningPopoverText2"
                defaultMessage="If you make payment in some way
                    other than via stugknuten.com,
                    we will not be able to assist in the event of any problems."
              />
            </Typography>
          )}
          {isHost && (
            <Typography>
              <FormattedMessage
                id="conversations.warningPopoverText5"
                defaultMessage="This accommodation is S-certified. We recommend that all communication takes place via stugknuten.com."
              />
              <br />
              <br />
              <FormattedMessage
                id="conversations.warningPopoverText6"
                defaultMessage="Payment should go via stugknuten.com. Transaction is performed when guest approves and pays the booking offer."
              />
            </Typography>
          )}

          {terminationWarning && (
            <Box mt={2}>
              <Typography>
                <FormattedMessage
                  id="conversations.warningPopoverText3"
                  defaultMessage="If payment is made outside of Stugknuten, it violates the terms of the service."
                />
              </Typography>

              <Box mt={1} textAlign="right">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    onCancel();
                    this.handlePopoverClose();
                  }}
                  className={classes.smallBtn}
                >
                  <FormattedMessage id="Cancel" defaultMessage="Cancel" />
                </Button>
                &nbsp;
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={this.handlePopoverClose}
                  className={classes.smallBtn}
                >
                  <FormattedMessage id="Ok" defaultMessage="Ok" />
                </Button>
              </Box>
            </Box>
          )}
        </Popover>
      </>
    );
  }
}

ContactsWarning.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  placeholder: PropTypes.node,
  onCancel: PropTypes.func,
  terminationWarning: PropTypes.bool,
  isHost: PropTypes.bool,
};

export default withStyles(styles)(ContactsWarning);
